
import { TradingEntitlements } from '../../models/common/trading-entitlements';
import { AddlOrdData, TradingExchangeOrder, OrderType } from '../../models/common/trading-common.model';

export function isOrderInstructionsSelectEnabled(selectedConditions: string[]): boolean {
    if ( selectedConditions === null || selectedConditions.length === 0 ) {
        return false;
    }

    let i: number;

    for ( i = 0; i < selectedConditions.length; i++ ) {
        if ( selectedConditions[i] === AddlOrdData.NOTHELD ) {
            return true;
        }
    }

    return false;
}

function isDoNotIncreaseOptionToBeDisabled(optionName:string, selectedCondition:string) :boolean {
    return optionName === 'DONOTINCREASE' && (selectedCondition === AddlOrdData.DONOTREDUCE || selectedCondition === AddlOrdData.NEXTDAY || selectedCondition === AddlOrdData.CASHSAMEDAY);    
}

function isDoNotReduceOptionToBeDisabled(optionName:string, selectedCondition:string) :boolean {
    return optionName === 'DONOTREDUCE' && (selectedCondition === AddlOrdData.DONOTINCREASE || selectedCondition === AddlOrdData.NEXTDAY || selectedCondition === AddlOrdData.CASHSAMEDAY);
}

function isNextDayOptionToBeDisabled(optionName:string, selectedCondition:string) :boolean {
    return optionName === 'NEXTDAY' && (selectedCondition === AddlOrdData.DONOTINCREASE || selectedCondition === AddlOrdData.DONOTREDUCE || selectedCondition === AddlOrdData.CASHSAMEDAY); 
}

function isCashSameDayOptionToBeDisabled(optionName:string, selectedCondition:string) :boolean {
    return optionName === 'CASHSAMEDAY' && (selectedCondition === AddlOrdData.DONOTINCREASE || selectedCondition === AddlOrdData.DONOTREDUCE || selectedCondition === AddlOrdData.NEXTDAY);
}

export function isOrderInstructionsOptionToBeDisabled(optionName: string, selectedConditions: string[]): boolean {
    if ( selectedConditions === null || selectedConditions.length === 0 ) {
        return false;
    }

    let i: number;

    for ( i = 0; i < selectedConditions.length; i++ ) {
        if (isDoNotIncreaseOptionToBeDisabled(optionName,selectedConditions[i])) 
        {
            return true;
        }

        if (isDoNotReduceOptionToBeDisabled(optionName,selectedConditions[i])) 
        {
            return true;
        }

        if(isNextDayOptionToBeDisabled(optionName,selectedConditions[i]))
        {
            return true;
        }

        if (isCashSameDayOptionToBeDisabled(optionName,selectedConditions[i])) 
        {
            return true;
        }
    }

    return false;
}

// Don't show the estimated value for MARKET orders for retail users if they don't have realtime entitlement and have not agreed the exchange agreement.
export function isEstimatedValueApplicable(entitlements: TradingEntitlements, order: TradingExchangeOrder): boolean {
    let orderType = order.orderType;
    if (orderType === OrderType.MARKET) {
        if (entitlements.isProfessionalUser || (entitlements.isRetailUser && entitlements.isRTQuotesEnabled && entitlements.isExchangeAgreementSignedByUser)) {
            return true;
        } else {
            return false;
        }
    }

    return true;

}

// for NXI we are getting the routeContext as a query string, this function converts it into the proper JSON format
export function convertRouteContextStringToObj(routeContext, platform) {
    if (!!routeContext && typeof routeContext === 'string' && platform === 'retail') {
        routeContext = JSON.parse('{"' + decodeURI(routeContext).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}');
    }

    return routeContext;
}
